// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"417":"794742d0","627":"e14d2dcd","647":"85d6a881","795":"05f7a671"}[chunkId] + ".css";
};